
import { createContext, useContext } from 'react';
import { AuthContextType } from '../types/AuthTypes';

// Create the context with a default value
const SupabaseAuthContext = createContext<AuthContextType>({
  // Default values
  user: null,
  isLoading: true,
  isAuthenticated: false,
  
  // Default methods (will be overridden by provider)
  signIn: async () => null,
  signUp: async () => null,
  signOut: async () => {},
  updateProfile: async () => null,
  getProfile: async () => null,
  hasRole: () => false,
  refreshUser: async () => null,
});

// Custom hook to use the auth context
export const useSupabaseAuth = () => useContext(SupabaseAuthContext);

export default SupabaseAuthContext;
